import { Dispatch, SetStateAction } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { IUserData } from "../../interfaces/forms";

import useToast from "../useToast";

import { saveUsers } from "../../services/users";

export interface IPayload {
    payload: IUserData[];
    setIsProcessing: Dispatch<SetStateAction<boolean>>;
};

export interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
};

const useSaveUsers = () => {
    const queryClient = useQueryClient();

    const { addToast } = useToast();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        return await saveUsers(data.payload);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
        },
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response?.statusCode === 200) {
                addToast({
                    type: 'success',
                    title: 'Organization & Users saved successfully.',
                });

                queryClient.invalidateQueries({ queryKey: ['organizations_tree'] });
                queryClient.invalidateQueries({ queryKey: ['users'] });
            };
        },
        onError: (error: IResponse, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error.message
            });
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useSaveUsers;